import { Component, Input, OnInit } from '@angular/core';
import { BENEFITS } from '../value-proposition/value-proposition.component';

@Component({
  selector: 'app-value-proposition-vertical',
  templateUrl: './value-proposition-vertical.component.html',
  styleUrls: ['./value-proposition-vertical.component.scss']
})
export class ValuePropositionVerticalComponent implements OnInit {
  BENEFITS = BENEFITS;
  @Input() highlight: boolean;

  constructor() {}

  ngOnInit(): void {}
}
